import { useState } from 'react';
import { ValidationErrorCode } from '@common/enums/validationErrorCode';
import { getSelectedLanguage } from '@frontend/translate';
import { useAbortableFetch } from '@frontend/utils/hooks/useAbortableFetch';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { ToastType } from '../../../../common/enums/toastType';
import { showToast } from '../../../utils/showToast';
import { Button } from '../common';
import { ProcessAlreadyTakenModal } from '../modals/ProcessAlreadyTakenModal';

export function AcceptReferralButton(props: {
    reloadProcess: () => Promise<void>;
    request: IRequestGetOne;
    showConfirmationMessage?: boolean;
}) {
    const language = getSelectedLanguage();
    const abortableFetch = useAbortableFetch();
    const [showProcessAlreadyTakenMessage, setShowProcessAlreadyTakenMessage] = useState(false);

    if (!props.request.authorization?.canUpdateRequestToAccepted) {
        return null;
    }

    return (
        <>
            <Button
                automation="acceptReferral"
                color="secondary"
                large
                onClick={handleTakeProcess}
            >
                {language.request.statusAction_accepted}
            </Button>
            <ProcessAlreadyTakenModal
                isOpen={showProcessAlreadyTakenMessage}
                onClose={async () => {
                    setShowProcessAlreadyTakenMessage(false);
                    await props.reloadProcess!();
                }}
                serviceType={props.request.serviceType}
            />
        </>
    );

    async function handleTakeProcess() {
        const url = `/api/requests/${props.request.id}/takeProcess`;
        const result = await abortableFetch.fetchJson(url, 'POST', undefined, [
            ValidationErrorCode.PROCESS_ALREADY_TAKEN_BY_COLLEAGUE,
        ]);

        if (result?.errorCode === ValidationErrorCode.PROCESS_ALREADY_TAKEN_BY_COLLEAGUE) {
            setShowProcessAlreadyTakenMessage(true);
        } else {
            await props.reloadProcess();
            if (props.showConfirmationMessage) {
                showToast(ToastType.success, language.referral.referralAccepted);
            }
        }
    }
}
